module.exports = __webpack_public_path__ + "static/img/29.d8d0be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/29.jpg
// module id = WJ6W
// module chunks = 0